(ns livefeed.modal
  (:require [livefeed.i18n :refer [translate]]
            [livefeed.icons :as icons]))

(defn component [{:keys [on-close] :as props} & children]
  (let [modal-props (dissoc props :on-close)]
    [:div.modal__backdrop
     (into [:div.modal modal-props
            (when on-close
              [:button.modal__close-button {:on-click   on-close
                                            :title (translate :close)
                                            :aria-label (translate :close)}
               icons/close])]
           children)]))

(defn blocked [on-close]
  [component {:class    :blocked-modal
              :on-close on-close}
   [:h2.blocked-modal__header
    (translate :blocked-title)]
   [:p.blocked-modal__content
    (translate :blocked-text-1)]
   [:p.blocked-modal__content
    (translate :blocked-text-2)]
   [:p.blocked-modal__content
    (translate :blocked-text-3)]
   [:p.blocked-modal__content
    (translate :blocked-text-4) [:a {:href (translate :blocked-url)} (translate :blocked-text-5)] "."]])
